var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTopFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    clipPath: "url(#clip0_183_47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.217773 29.8227L14.0218 23.2882L14.0856 0.184204L0.217773 29.8227Z",
    fill: "#FF9759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0215 23.2882L14.181 23.2139L27.8175 30.1818L14.1371 0.0727539L14.0853 0.184208L14.0215 23.2882Z",
    fill: "#FA793F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6,
    height: 30.1091,
    fill: "white",
    transform: "translate(0.217773 0.0727539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopFill);
export default __webpack_public_path__ + "static/media/arrow-top-fill.4cdc0baae2aa49b433fa02e9eb1b1e12.svg";
export { ForwardRef as ReactComponent };